export enum UserDomainEnum {
  System = 'system',
  Informal = 'informal',
  Formal = 'formal',
}
